import { Box, SheetViewer, Text } from 'shell/components';

const CSV_URL =
    'https://timelygrader-us-upload-app-sandbox.s3.amazonaws.com/0ee2f546-ade1-4418-aa3d-1e8992b6234e/Task%20page%20crash%20tried%20out%20methods%20-%20Sheet1.csv';
const XLSX_URL =
    // 'https://timelygrader-us-upload-app-sandbox.s3.amazonaws.com/6b044dc3-190c-4d96-bc8e-78d2af3d0f27/Task%20page%20crash%20tried%20out%20methods.xlsx';
    'https://timelygrader-us-upload-app-sandbox.s3.amazonaws.com/0f5221ff-b483-4fae-80b8-a0a1685944ab/WBS_Expanded_Sample_Formatted_v2%20(1).xlsx';
// 'https://timelygrader-us-upload-app-sandbox.s3.amazonaws.com/0e4c534f-2c12-42a2-a8db-575548b27fe8/WBS_Sample_Submission.xlsx';

const highlights = [
    {
        id: 1,
        value: {
            row: 2,
            col: 1,
        },
    },
    {
        id: 2,
        value: {
            row: 2,
            col: 2,
        },
    },
    {
        id: 3,
        value: {
            row: 2,
            col: 3,
        },
    },
    {
        id: 4,
        value: {
            row: 2,
            col: 4,
        },
    },
    {
        id: 5,
        value: {
            row: 3,
            col: 3,
        },
    },
    {
        id: 6,
        value: {
            row: 3,
            col: 4,
        },
    },
    {
        id: 7,
        value: {
            row: 3,
            col: 5,
        },
    },
    {
        id: 8,
        value: {
            row: 4,
            col: 4,
        },
    },
    {
        id: 9,
        value: {
            row: 23,
            col: 1,
        },
    },
    {
        id: 10,
        value: {
            row: 23,
            col: 2,
        },
    },
    {
        id: 11,
        value: {
            row: 23,
            col: 3,
        },
    },
    {
        id: 12,
        value: {
            row: 23,
            col: 4,
        },
    },
    {
        id: 13,
        value: {
            row: 23,
            col: 5,
        },
    },
];

const SheetViewerDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>SheetViewer</Text>
            <Box sx={{ width: '612px', height: '792px' }}>
                <SheetViewer highlights={highlights} url={XLSX_URL} />
            </Box>
            <Box sx={{ width: '612px', height: '792px' }}>
                <SheetViewer highlights={[]} url={CSV_URL} />
            </Box>
        </>
    );
};

export default SheetViewerDemo;
